import Cookies from 'js-cookie';

const skript = document.createElement('script');
const skript2 = document.createElement('script');

export const setGTM = (containerId: string | undefined) => {
    let cookiesAccepted = Cookies.get('CookieConsent');

    const gtmSkript =
        '  window.dataLayer = window.dataLayer || [];' +
        '  function gtag(){dataLayer.push(arguments);}' +
        "  gtag('js', new Date());" +
        "  gtag('config', '" +
        containerId +
        "');";

    if (cookiesAccepted && containerId) {
        skript.src = `https://www.googletagmanager.com/gtag/js?id="${containerId}"`;

        const skriptText = document.createTextNode(gtmSkript);
        skript2.appendChild(skriptText);

        document.head.appendChild(skript);
        document.head.appendChild(skript2);
    }
};

export const resetGTM = () => {
    document.head.removeChild(skript);
    document.head.removeChild(skript2);
};
